import {
  AudioRecordingModelData,
  AudioRecordingUploadStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkStartedUploadingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_STARTED_UPLOADING_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    // Don't transition back from COMPLETED state
    if (existingData.upload_status === AudioRecordingUploadStatus.COMPLETED) {
      return {};
    }
    return {
      upload_status: AudioRecordingUploadStatus.IN_PROGRESS,
    };
  }
}
